import { AutoCompleteComponent } from '../components/‏‏auto-complete/auto-complete.cmp';
import { ModalService } from './../components/modal/modal.svc';
//import { UpdateCashRegisterDlg } from './ivrDonationDetails-updateCashRegister-dlg.cmp';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
//import { MatSelect } from '@angular/material/select';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { IvrDonationDetailsData } from './ivrDonationDetails.data';

import { Component, OnInit, ViewChild, Input, Output, } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ServicesData } from '../services/services.data';
import { Router } from '@angular/router';
import { IndexService } from '../services/index-service';
import { EventEmitter } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { X } from '@angular/cdk/keycodes';

@Component({
  selector: 'ivrDonationDetails-list',
  templateUrl: 'ivrDonationDetails-list.tmpl.html'
})

export class IvrDonationDetailsList implements OnInit {
  constructor(
    private ivrDonationDetailsData: IvrDonationDetailsData,
    private formBuilder: FormBuilder,
    public servicesData: ServicesData,
    private modal: ModalService,
    private router: Router,
    public _matDialog: MatDialog,
  ) {
  }

  displayedColumns: string[] = ['buttons', 'select', 'ivrDonationDetailID', 'lastName', 'shtibelName', 'phoneNumber', 'title', 'createDate', 'amount', 'qty', 'statusPayment', 'methodTitle', 'commitmentID'];

  panelOpenState;
  data: any[] = [];
  defaultvalues;
  indexService: IndexService;
  actualMinusHeight = '185';
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input('contactID') public contactID?: number | null = null;
  @Input('ivrDonationDetailID') public ivrDonationDetailID?: number | null = null;
  @Output() selectedRowsChange = new EventEmitter<any>();




  selection = new SelectionModel<number>(true, []);
  stopLoadingPoints: boolean = false;
  searchIvrDonationDetailsListForm: FormGroup;

  addNew() {
    this.router.navigate([{ outlets: { popup: ['add'] } }]);
  }
  updateHandlingDate() {

     console.log(this.selection);
    let selectedIds = this.searchIvrDonationDetailsListForm.controls['selectedRows'].value.map(x => x).join();

    this.ivrDonationDetailsData.updateHandlingDate(selectedIds)
      .subscribe(x => {
        console.log(x);
      }

      )

  }
  openSelectedRow(ivrDonationDetailID) {
    this.router.navigate(['', { outlets: { popup: ['ivrDonationDetails', ivrDonationDetailID] } }]);
  }


  public downloadExcel() {
    this.ivrDonationDetailsData.exportExcel(this.searchIvrDonationDetailsListForm.value)
      .subscribe(blob => {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `תרומות טלפוניות.xlsx`;
        link.click();
      });
  }


  private initForm() {
    this.searchIvrDonationDetailsListForm = this.formBuilder.group({
      page: [1],
      pageRows: [20],
      query: [],
      ivrDonationDetailID: [],
      currency: [],
      dateRange: [],
      statusPayment: [],
      donationCategoryTitle: [],
      registeringPhone: [],
      callerNumber: [],
      contactID: [],
      contactName: [],
      donationCategoryIDs: [null],
      statusPayments: [null],
      isHandlingDate: [null],
      selectedRows: [],
      orders: this.formBuilder.array([])
    });
  }

  ngOnInit() {
    this.stopLoadingPoints = true;
    this.initForm();


    let params = [
      { key: "contactID", value: this.contactID },
    ];


    this.indexService = new IndexService(this.searchIvrDonationDetailsListForm, params, this.ivrDonationDetailsData, this.router, this.defaultvalues, '', '', '');
    let item = sessionStorage.getItem(this.router.url);
    if (item && this.ivrDonationDetailsData.url == this.router.url) { //TODO: יש לטפל עדיין בבדיקה הזו
      let frm = JSON.parse(sessionStorage.getItem(this.router.url) || "");
      this.searchIvrDonationDetailsListForm.patchValue(frm);
      if (frm.orders) {
        frm.orders.forEach(x => { this.indexService.addOrder(x.key, x.value) });
      }
    }


    this.indexService.getList();

    this.indexService.selection.changed.subscribe(x => {
      this.searchIvrDonationDetailsListForm.controls['selectedRows'].setValue(x.source.selected.map((x: any) => x.ivrDonationDetailID));
      this.selectedRowsChange.emit(x.source.selected);
    });
  }
}
